/* eslint-disable */
import { DownOutlined } from '@ant-design/icons';
import { UpOutlined }   from '@ant-design/icons';
import Card             from 'antd/lib/card';
import { CardProps }    from 'antd/lib/card';
import Spin             from 'antd/lib/spin';
import View             from 'components/View';
import { matchPath }    from 'react-router-dom';
import React            from 'react';
import routes           from 'routes/privates';
import ReactDomServer   from 'react-dom/server';
import './DashboardBox.scss';
import ButtonEllipsis   from 'components/ButtonEllipsis';

type DashboardBoxProps = {
	cardProps?: CardProps;
	children: React.ReactNode;
	collapsable?: boolean;
	defaultCollapsed?: boolean;
	leftComponent?: React.ReactElement;
	loading?: boolean;
	noHead?: boolean;
	noPadding?: boolean;
	noShadow?: boolean;
	title?: React.ReactNode;
	topRightActions?: () => React.ComponentProps<typeof ButtonEllipsis>['actions'];
	topRightComponent?: React.ReactElement | React.ReactElement[];
	width?: number | string;
	keepMountedOnCollapse?: boolean;
};

export const COLLAPSED_BOXES_STORAGE_KEY = 'COLLAPSED_BOXES';

export default (props: DashboardBoxProps) => {
	const {
		cardProps,
		children,
		defaultCollapsed,
		leftComponent,
		loading,
		noHead,
		noPadding,
		noShadow,
		title,
		topRightActions,
		topRightComponent,
		width,
		keepMountedOnCollapse,
	} = props;

	const collapsable = typeof props.collapsable === 'undefined' || props.collapsable;
	const [collapsed, setCollapsed] = React.useState(!!defaultCollapsed);
	const storageKey = React.useRef('');

	React.useEffect(() => {
		const currentRoute = routes.find(route => matchPath(location.pathname, route));
		// @ts-ignore
		storageKey.current = `${currentRoute?.path || location.pathname}_${ReactDomServer.renderToString(title || '')}`;
		const storage = JSON.parse(localStorage.getItem(COLLAPSED_BOXES_STORAGE_KEY) || '{}');
		setCollapsed(!!storage[storageKey.current]);
		defaultCollapsed === false && toggleCollapse();
	}, []);

	const classNames = [
		'DashboardBox',
		collapsed ? 'collapsed' : '',
		(noPadding || collapsed) ? 'no-padding' : '',
		noShadow ? 'no-shadow' : '',
		noHead ? 'no-head' : '',
	];

	const toggleCollapse = () => {
		setCollapsed(!collapsed);

		const storage = JSON.parse(localStorage.getItem(COLLAPSED_BOXES_STORAGE_KEY) || '{}');

		if (collapsed) {
			delete storage[storageKey.current];
		} else {
			storage[storageKey.current] = true;
		}

		localStorage.setItem(COLLAPSED_BOXES_STORAGE_KEY, JSON.stringify(storage));
	};

	return (
		<Card
			className={classNames.join(' ')}
			extra={(
				<View centerV gapH={10} className="DashboardBox__extra" row>
					<View gap={10} row>
						{topRightComponent}

						{!!topRightActions && <ButtonEllipsis actions={topRightActions()} />}
					</View>
				</View>
			)}
			style={width ? { width } : {}}
			title={title ? (
				<View
					centerV
					color="rgba(0, 0, 0, .4)"
					gap={10}
					onClick={collapsable ? toggleCollapse.bind(this) : undefined}
					pointer={collapsable}
					row
				>
					{!!leftComponent && leftComponent}

					<div className="DashboardBox__titleTitle">
						{title}
					</div>

					{collapsable && <View marginR={10} size={12}>{collapsed ? <DownOutlined /> : <UpOutlined />}</View>}
				</View>
			) : undefined}
			{...cardProps}
		>
			{(() => {
				if (!collapsed && loading) {
					return <Spin style={{ padding: 40, width: '100%' }} />;
				}

				if (keepMountedOnCollapse) {
					return <View className="fade-in" hidden={collapsed}>{children}</View>;
				}

				if (!collapsed) {
					return <div className="fade-in">{children}</div>;
				}

				return null;
			})()}
		</Card>
	);
};
